/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TokenRouteImport } from './routes/$token'
import { Route as IndexRouteImport } from './routes/index'

const TokenRoute = TokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$token': typeof TokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$token': typeof TokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$token': typeof TokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$token'
  id: '__root__' | '/' | '/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TokenRoute: typeof TokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$token': {
      id: '/$token'
      path: '/$token'
      fullPath: '/$token'
      preLoaderRoute: typeof TokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TokenRoute: TokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
